"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.StepperButton = exports.Stepper = exports.HelperTextCount = exports.HelperText = exports.HelperContainer = void 0;
var styles_1 = require("@mui/material/styles");
var prism_icons_1 = require("@octanner/prism-icons");
var colors_1 = require("../ThemeProvider/colors");
exports.HelperContainer = (0, styles_1.styled)('span')({
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 12,
});
exports.HelperText = (0, styles_1.styled)('span', {
    shouldForwardProp: function (prop) { return prop !== 'error'; },
})(function (_a) {
    var _b = _a.error, error = _b === void 0 ? false : _b;
    return ({
        width: 1,
        overflowWrap: 'break-word',
        flex: '1 1 auto',
        ariaLive: 'polite',
        color: error ? colors_1.tannerSemantic.error.color : colors_1.tannerGray['600'],
    });
});
exports.HelperTextCount = (0, styles_1.styled)('span')({
    flex: '0 0 auto',
});
exports.Stepper = (0, styles_1.styled)('div', {
    shouldForwardProp: function (prop) { return prop !== 'disabled'; },
})(function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        fontSize: 12,
        pointerEvents: disabled ? 'none' : 'auto',
    });
});
exports.StepperButton = (0, styles_1.styled)('div')({
    '&:first-of-type': {
        alignItems: 'flex-end',
    },
    '&:last-of-type': {
        alignItems: 'flex-start',
    },
    color: colors_1.tannerGray['400'],
    cursor: 'pointer',
    '&:hover': {
        color: '#000',
    },
    display: 'flex',
    flexBasis: '50%',
    transition: 'color 200ms',
});
exports.CloseButton = (0, styles_1.styled)(prism_icons_1.Close, {
    shouldForwardProp: function (prop) { return prop !== 'hasValue'; },
})(function (_a) {
    var _b = _a.hasValue, hasValue = _b === void 0 ? false : _b;
    return ({
        color: hasValue ? colors_1.tannerGray['600'] : 'transparent',
        cursor: 'pointer',
        fontSize: 16,
    });
});
//# sourceMappingURL=styles.js.map